/**
 * AxLabs Experiments - Main Index
 *
 * Exports all experiments across all domains and the declarative framework.
 */
// Physics experiments
export * from './physics/index.js';
// Chemistry experiments
export * from './chemistry/index.js';
// Biology experiments
export * from './biology/index.js';
// Mathematics experiments
export * from './mathematics/index.js';
// Declarative framework for creating experiments from config
export * from './framework/index.js';
// Collect all experiments
import { PHYSICS_EXPERIMENTS, MANUAL_PHYSICS_EXPERIMENTS, GENERATED_PHYSICS_EXPERIMENTS, } from './physics/index.js';
import { CHEMISTRY_EXPERIMENTS, MANUAL_CHEMISTRY_EXPERIMENTS, GENERATED_CHEMISTRY_EXPERIMENTS, } from './chemistry/index.js';
import { BIOLOGY_EXPERIMENTS, MANUAL_BIOLOGY_EXPERIMENTS, GENERATED_BIOLOGY_EXPERIMENTS, } from './biology/index.js';
import { MATHEMATICS_EXPERIMENTS, MANUAL_MATHEMATICS_EXPERIMENTS, GENERATED_MATHEMATICS_EXPERIMENTS, } from './mathematics/index.js';
/**
 * Manual experiments - these use ExperimentConfig from simulation-core
 * Each has a dedicated SimulationEngine implementation
 */
export const MANUAL_EXPERIMENTS = [
    ...MANUAL_PHYSICS_EXPERIMENTS,
    ...MANUAL_CHEMISTRY_EXPERIMENTS,
    ...MANUAL_BIOLOGY_EXPERIMENTS,
    ...MANUAL_MATHEMATICS_EXPERIMENTS,
];
/**
 * Generated experiments - these are GeneratedExperimentClass instances
 * created from ExperimentSchema using the declarative framework
 */
export const GENERATED_EXPERIMENTS = [
    ...GENERATED_PHYSICS_EXPERIMENTS,
    ...GENERATED_CHEMISTRY_EXPERIMENTS,
    ...GENERATED_BIOLOGY_EXPERIMENTS,
    ...GENERATED_MATHEMATICS_EXPERIMENTS,
];
/**
 * All experiment configs (for backward compatibility).
 * Contains just the config parts, not the full schemas.
 */
export const ALL_EXPERIMENTS = [
    ...PHYSICS_EXPERIMENTS,
    ...CHEMISTRY_EXPERIMENTS,
    ...BIOLOGY_EXPERIMENTS,
    ...MATHEMATICS_EXPERIMENTS,
];
// Re-export domain arrays
export { PHYSICS_EXPERIMENTS, CHEMISTRY_EXPERIMENTS, BIOLOGY_EXPERIMENTS, MATHEMATICS_EXPERIMENTS };
//# sourceMappingURL=index.js.map